// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Timer_wrapper__xP7XV","heading":"Timer_heading__1Na9A"};